// 触发 Match 庆祝特效的副作用：振动 + 三连鸣音效。
// 始终一起触发，不探测静音模式（浏览器无可靠 API）。

type AudioContextCtor = typeof AudioContext;

let cachedCtx: AudioContext | null = null;
function getCtx(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (cachedCtx) return cachedCtx;
  const w = window as unknown as {
    AudioContext?: AudioContextCtor;
    webkitAudioContext?: AudioContextCtor;
  };
  const Ctor = w.AudioContext ?? w.webkitAudioContext;
  if (!Ctor) return null;
  cachedCtx = new Ctor();
  return cachedCtx;
}

function tone(ctx: AudioContext, freq: number, startAt: number, durationMs: number): void {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  const t0 = startAt;
  const t1 = t0 + 0.005;
  const t2 = t0 + durationMs / 1000 - 0.03;
  const t3 = t0 + durationMs / 1000;
  gain.gain.setValueAtTime(0, t0);
  gain.gain.linearRampToValueAtTime(0.18, t1);
  gain.gain.setValueAtTime(0.18, t2);
  gain.gain.linearRampToValueAtTime(0, t3);
  osc.connect(gain).connect(ctx.destination);
  osc.start(t0);
  osc.stop(t3 + 0.05);
}

export function playMatchSound(): void {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === 'suspended') void ctx.resume().catch(() => undefined);
  const t = ctx.currentTime;
  tone(ctx, 523.25, t + 0.0, 80);
  tone(ctx, 659.25, t + 0.1, 80);
  tone(ctx, 783.99, t + 0.2, 140);
}

export function vibrateMatch(): void {
  if (typeof navigator === 'undefined') return;
  if (!('vibrate' in navigator)) return;
  try {
    navigator.vibrate([60, 30, 60, 30, 100]);
  } catch {
    // unsupported
  }
}

export function celebrateMatch(): void {
  vibrateMatch();
  playMatchSound();
}
